// const BASEURL = 'http://192.168.0.134:8094/';

const BASEURL = 'https://abdmapi.lalpathlabs.com/';
const API_URL = {
  BASEURL: BASEURL,
  API_BASEURL: `${BASEURL}api/v1/`,
  IMAGE_URL: BASEURL,
  LOGIN: `auth/signin?token=60f291aa46ea447060f291aa46ea447019d83ba30be508e419d83ba30be508e4`,
  // DOCUMENTPATH: `https://liveapi.lalpathlabs.com/`,
  DASHBOARD_FAQ_COUNT: `/dashboard/faqs/count`,
  DASHBOARD_USER_COUNT: `/dashboard/users/count`,
  DASHBOARD_JOB_ADD_COUNT: `/dashboard/jobs/count`,
  USER_LIST: `/users/list`,
  USER_ADD: `/users/add`,
  USER_UPDATE: `/users/update`,
  USER_STATUS_UPDATE: `/users/update/status`,
  UPDATE_PASSWORD: `/users/changepassword`,
  USER_BY_ID: `/users/details`,
  ROLE_LIST: `/role/list`,
  ROLE_ADD: `/role/add`,
  ROLE_UPDATE: `/role/update`,
  ROLE_BY_ID: `/role/details`,
  FILTER_DATA: '/master/filterdata',
  PERMISSION_UPDATE: '/role/updatepermissions',
  ABHA_CREATED_LIST: `admin/getCardLogs`,
  ABHA_LINK_NOTIFY: `hip/link-record`,
  ABDM_UPLOAD_FILE: `s3/upload/file`,
  FAQ_LIST: `/faqs/list`,
  FAQ_ADD: `/faqs/add`,
  FAQ_UPDATE: `/faqs/update`,
  FAQ_BY_ID: `/faqs/details`,
  FAQ_CATEGORY_LIST: `faqs/category/list`,
  FAQ_CATEGORY_ADD: `/faqs/category/add`,
  FAQ_CATEGORY_UPDATE: `/faqs/category/update`,
  FAQ_CATEGORY_BY_ID: `/faqs/category/details`,
};
export default API_URL;
